<template>
  <el-dialog
    :visible.sync="visible"
    :title="$t('Düzəliş_logları')"
    width="80%"
    top="10vh"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    @close="handleClose"
    class="custom-log-dialog"
  >
    <div class="scroll-container" v-loading="loading">

      <div v-if="processedLogDiffs.length === 0" class="no-logs-message">{{$t('Düzəliş_tapılmadı')}}</div>

      <div
        v-else
        v-for="(log, index) in processedLogDiffs"
        :key="index"
        class="log-block"
      >
        <div class="log-header">
          Düzəliş olunub: {{ getUpdatedBy(log.changes) }}
        </div>

        <div v-if="filteredChanges(log.changes).length === 0" class="no-logs-message">{{$t('Düzəliş_tapılmadı')}}</div>

        <el-table
          v-else
          :data="filteredChanges(log.changes)"
          border
          class="log-table"
        >
          <el-table-column :label="$t('Sütun')" prop="keyDisplay" min-width="200" />
          <el-table-column :label="$t('Düzəlişdən_sonra')" prop="current" min-width="200">
            <template v-slot="scope">
              <span>{{ scope.row.current }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Əvvəl')" prop="prev" min-width="200">
            <template v-slot="scope">
              <span>{{ scope.row.prev }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" class="close-button">{{$t('Bağla')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'LogChangesDialog',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    processedLogDiffs: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },
    getUpdatedBy(changes) {
      const updated = changes.find(c => c.key === 'UpdatedBy');
      return updated?.current || '';
    },
    filteredChanges(changes) {
      return changes.filter(c => c.key !== 'UpdatedBy');
    }
  }
};
</script>

<style scoped>
.custom-log-dialog >>> .el-dialog__body {
  padding: 0 !important;
}
.scroll-container {
  max-height: 60vh;
  overflow-y: auto;
  padding: 8px 10px 8px 10px;
}

.log-header {
  background-color: #f8f8f8;
  padding: 2px 12px;
  font-weight: bold;
  color: #303133;
  border: 1px solid #e0e0e0;
  margin-top: 8px;
  font-size: var(--font-primary);
}

.log-table {
  width: 100%;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
}

.close-button {
  margin-left: 10px;
}

.no-logs-message {
  text-align: center;
  padding: 20px;
  color: #909399;
  font-size: var(--font-primary);
  font-weight: 500;
}

</style>
